// Backward-compatible restaurant view over the central tenant config.
// All customizable data now lives in src/config/restaurantConfig.js.
import { restaurantConfig, resolveTableFromSlug } from "@/config/restaurantConfig";

export const restaurant = {
  id: restaurantConfig.id,
  name: restaurantConfig.name,
  tagline: restaurantConfig.tagline,
  logoImage: restaurantConfig.logoImage,
  branch: restaurantConfig.branch,
  isOpen: restaurantConfig.isOpen,
  hours: restaurantConfig.hours,
  avgPrepTimeMin: restaurantConfig.avgPrepTimeMin,
  rating: restaurantConfig.rating,
  reviewCount: restaurantConfig.reviewCount,
  currency: restaurantConfig.currency,
  locale: restaurantConfig.currencyLocale,
  heroImage: restaurantConfig.coverImage,
};

export { resolveTableFromSlug, restaurantConfig };
